/* eslint-disable no-console */

import axios from 'axios'
import Paginator from 'models/Paginator'
import { API_URL } from 'services/config'

// mock
// const currentAccount = require('mocks/CurrentAccount/currentAccount.json')
// const liquidation = require('mocks/CurrentAccount/liquidation.json')

class CurrentAccountService {
    getCurrentAccount = async (params) => {
        try {
            const response = await axios.get(`${API_URL}/liquidations`, { params });
            const { data: { data, pagination } } = response;
    
            return {
                data,
                paginator: Paginator.fromJson(pagination),
            };
        } catch (error) {
            console.error("Error fetching checking account:", error);
            throw error;
        }
    };
    

    getLiquidation = async(id) => {
        try {
            const { data } = await axios.get(`${API_URL}/liquidations/${id}`)
            return data
        } catch (error) {
            console.error("Error fetching liquidation detail:", error);
            throw error;
        }
    }

    uploadBillFile = async(payload) => {
        try {
            await axios.post(`${API_URL}/liquidations/invoice`, payload)
            return true
        } catch (error) {
            console.error("Error uploading invoice: ", error);
            throw error;
        }
    }
}

export default CurrentAccountService
